module.exports = __webpack_public_path__ + "static/media/arrowRight.abc8e48b.svg";